/**
 * Utility functions and constants for English assessment features
 */
import { stringUtils } from '@/utils';

/**
 * The order in which English assessment scores should be displayed
 */
export const scoreOrder = [
  'fluency',
  'vocabulary',
  'pronunciation',
  'grammar',
  'interaction',
];

/**
 * Processes detailed scores and returns them in the specified order
 * @param {Object<string, string>} scores - The detailed scores object
 * @returns {Array<{label: string, value: string}>} - Ordered array of score objects
 */
export const getOrderedScoreDetails = (scores) => {
  if (!scores) return [];

  return scoreOrder
    .filter((key) => key in scores)
    .map((key) => ({
      label: stringUtils.capitalizeFirstLetter(key),
      value: scores[key],
    }));
};

/**
 * Opens a report URL in a new tab
 * @param {string} reportUrl - The URL of the report to open
 */
export const openReport = (reportUrl) => {
  if (reportUrl) {
    window.open(reportUrl, '_blank');
  }
};

export default {
  scoreOrder,
  getOrderedScoreDetails,
  openReport,
};
